// @ts-nocheck
import React from 'react'
import { Button } from 'react-bootstrap'
import { useAuth0Login } from 'modules/useAuth0Login'
import type { RedirectLoginOptions, AppState } from "@auth0/auth0-react"

const LoginButton = ({ variant, size, saveAppState, text, email, phone, disabled, className, nextModal, sms = false, initialUrlParams = {} }) => {
  const { loginWithRedirect, loginWithPopup } = useAuth0Login()
  const options: RedirectLoginOptions<AppState> = {
    authorizationParams: {
      screen_hint: "login",
      login_hint: sms ? phone || undefined : email || undefined,
      connection: sms ? 'sms' : undefined,
    },
    appState: {
      returnTo: window.location.pathname
    },
  }

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      disabled={disabled}
      onClick={async () => {
        saveAppState(nextModal)
        if (window.top === window) {
          window.open(`${location.protocol}//${location.host}/login${sms ? `?login_type=phone&phone=${phone}` : `?email=${email}`}`, '_blank')
          return
        }
        await loginWithRedirect(options)
      }}
    >
      { text }
    </Button>
  )
}

export default LoginButton